import type { BlockDestination, PersistedBlock } from "schemas";
import { apiRequest } from "../apiRequest";
import { refetchParent } from "../blocks/refetchParent";
import { setBlock } from "../blocks/setBlock";

interface Args {
  pageId: string;
  pageElementId: string;
  destination: BlockDestination;
}

export async function clonePageElement({ pageId, pageElementId, destination }: Args) {
  const response = await apiRequest<{ block: PersistedBlock }>({
    url: `pageElements/${pageId}/elements/${pageElementId}/clone`,
    method: "POST",
  });

  setBlock(response.block);
  refetchParent(destination);
  return response.block;
}
